import { LIFT_TRACK, SOURCE_LABEL } from '../constants';

// Fields the Add Max form needs for an exercise
export const getMaxEntryFieldConfig = (exercise) => {
  if (!exercise) return { mode: 'weightReps', defaultReps: '1' };
  const {
    type, track, inputType, unit, unitName,
  } = exercise;

  if (type === 'L') {
    if (track === LIFT_TRACK.Weight) return { mode: 'weightOnly' };
    if (track === LIFT_TRACK.Reps) return { mode: 'repsOnly' };
    return { mode: 'weightReps', defaultReps: track === LIFT_TRACK.ThreeRepMax ? '3' : '1' };
  }
  if (type === 'C' || type === 'R') {
    if (inputType === 'T' && unit !== 'S') return { mode: 'timed' };
    if (unit === 'F') return { mode: 'feetInches' };
    if (unit === 'I') return { mode: 'inchesOnly' };
    return { mode: 'genericValue', unitLabel: unitName || 'Value' };
  }
  if (type === 'H') return { mode: 'health', unitLabel: unitName || 'Value' };
  return { mode: 'weightReps', defaultReps: '1' };
};

// Don't add a unit to a time like 5:00
export const withUnit = (value, unitAbbr) => {
  if (value === null || value === undefined || value === '') return null;
  const isFormattedTime = typeof value === 'string' && value.includes(':');
  return unitAbbr && !isFormattedTime ? `${value} ${unitAbbr}` : String(value);
};

// The backend sends "wgt" for weight so swap in the account's lbs or kg
export const resolveWeightUnitAbbr = (unitAbbr, orgWeight) => {
  if (unitAbbr !== 'wgt') return unitAbbr;
  return orgWeight === 1 ? 'kg' : 'lbs';
};

// Who a goal was set for - e.g. a group name or "All Athletes"
export const getGoalSourceLabel = (goal, { groups, calendars, athleteById }) => {
  if (goal.appliesToType === 'Account') return 'All Athletes';
  if (goal.appliesToType === 'Group') return groups.find((g) => g.id === goal.appliesToId)?.name;
  if (goal.appliesToType === 'Calendar') return calendars.find((c) => c.id === goal.appliesToId)?.name;
  if (goal.appliesToType === 'Athlete') {
    const athlete = athleteById[goal.appliesToId];
    return athlete && `${athlete.first} ${athlete.last}`;
  }
  return null;
};

// Where a max came from - e.g. "Workout" or "Linked from Back Squat"
export const getMaxSourceLabel = (source, exercisesById = {}) => {
  if (!source) return null;
  if (source.linked) {
    const linkedName = exercisesById[source.linkedExerciseId]?.name;
    return linkedName ? `Linked from ${linkedName}` : 'Linked exercise';
  }
  if (source.type === 'EVALUATION' && source.evaluationTitle) return source.evaluationTitle;
  return SOURCE_LABEL[source.type] || null;
};
